// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xnrhzmdxvbmxzbotwenm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhucmh6bWR4dmJteHpib3R3ZW5tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg0NzkxODEsImV4cCI6MjA1NDA1NTE4MX0.jyOrQTK4zXvJ8wDvkW3CiLMwzb74C1WKZvBgMluQB2Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);